import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { registrationQuery } from '#admin/features/registrations/queries.ts'

export const Route = createFileRoute('/_authenticated/ticketing/registrations/$registrationId')({
  staticData: { crumb: useRegistrationCrumb },
})

function useRegistrationCrumb(): string {
  const { registrationId } = Route.useParams()
  const { data } = useQuery(registrationQuery(registrationId))
  if (data === undefined) return 'Registration'
  return data.code ?? 'Draft registration'
}
